import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/MenuContainer' /* webpackChunkName: "MenuContainer" */),
  ],
  Classic: () => [
    import(
      './viewer/MenuContainer' /* webpackChunkName: "MenuContainer_Classic" */
    ),
  ],
  Responsive: () => [
    import(
      './viewer/skinComps/Responsive/Responsive.skin' /* webpackChunkName: "MenuContainer_Responsive" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('MenuContainer', UiTypes),
};

export default entry;
